// Helper function to safely parse and format dates (Safari compatible)
export const safeFormatDate = (dateStr: string): string => {
  try {
    const date = new Date(dateStr);

    if (isNaN(date.getTime())) {
      // Try parsing ISO format
      if (dateStr.includes(" ") && !dateStr.includes("T")) {
        const reformatted = dateStr.replace(" ", "T");
        const newDate = new Date(reformatted);
        if (!isNaN(newDate.getTime())) {
          return newDate.toISOString();
        }
      }

      return dateStr;
    }

    return date.toISOString();
  } catch (e) {
    console.warn("Date parsing error:", e);
    return dateStr; // Return original string as fallback
  }
};
